import { render, staticRenderFns } from "./MessangerChatGPT.vue?vue&type=template&id=3c83de8c&scoped=true"
import script from "./MessangerChatGPT.vue?vue&type=script&lang=js"
export * from "./MessangerChatGPT.vue?vue&type=script&lang=js"
import style0 from "./MessangerChatGPT.vue?vue&type=style&index=0&id=3c83de8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c83de8c",
  null
  
)

export default component.exports